import styled from 'styled-components';
import {
  Accordion as GrommetAccordion,
  AccordionPanel as GrommetAccordionPanel,
  Anchor as GrommetAnchor,
  Box as GrommetBox,
  Button as GrommetButton,
  CheckBox as GrommetCheckbox,
  Heading as GrommetHeading,
  Image as GrommetImage,
  Paragraph as GrommetParagraph,
  Select as GrommetSelect,
  Text as GrommetText,
  Video as GrommetVideo,
  Markdown as GrommetMarkdown,
  List as GrommetList,
  Layer as GrommetLayer,
} from 'grommet';
import mapPropsToStyles from '../../utils/mapPropsToStyle';
import commonStyles from '../../styles/commonStyles';
import iconError from '../../images/icon_error.svg';

export const Box = styled(GrommetBox)`
  ${(props) => mapPropsToStyles(props)};

  &.fullScreen {
    min-height: 100vh;
  }

  &.minFullSizeContent {
    flex-basis: calc(100vh - 2.25rem - 2.25rem);
  }

  &.mainContentTitleSpacing {
    padding-top: 1.25rem;
    border: none;
    td {
      div {
        display:block;
      }
    }
  }

  &.hpe_slim_header {
    .hpeslh_container {
      border-bottom: none !important;s
    }
    .hpehf-main-nav {
      border-bottom: none !important;
    }
  }

  &.hpe_slim_footer {
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 20 !important;
    height: 40px !important;
    border-top: none !important;

    #hpehf-footer{
      border-top: none !important;
    }
    #hpeslhf_copyright {
      font-size: 13px !important;
      padding: 2px 0 6px 0;
    }
    #hpeslhf_legal {
      font-size: 13px !important;
      padding: 2px 0 6px 0;
    }
  }

  &.autoMinHeight {
    min-height: auto !important;
    height: auto;
    padding-bottom: 1rem;
    padding-top: 1rem;
  }

  &.pageTitleBox {
    height: 40px;
    border-bottom: 1px solid #e6e6e6;
    margin-bottom: 20px;
  }
  &.markdownContent {
    table tbody td{
      vertical-align: top;
    }
    img {
      max-width: 100%;
    }
    a {
      ${commonStyles.lightDarkBlue};
      font-weight: normal;
      text-decoration: none;
    }
    a:hover{
      text-decoration: underline;
    }
    p {
      max-width: inherit;
      margin: 10px 0;
    }
  }
`;

export const Accordion = styled(GrommetAccordion)`
  ${(props) => mapPropsToStyles(props)};

  .checkbox-column {
    ${commonStyles.paddingTop4}
    width: 24px;
    margin-right: 20px;
  }

  .panel-column {
    button + div {
      border: 1px solid #eee;
    }
  }
`;

export const AccordionPanel = styled(GrommetAccordionPanel)`
  ${(props) => mapPropsToStyles(props)};

  .accordion-panel-title {
    ${commonStyles.semiBold};
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: left;
  }
`;

export const Anchor = styled(GrommetAnchor)`
  ${(props) => mapPropsToStyles(props)};

  &.swcfgDownloadLink {
    position: absolute;
    top: 26px;
  }

  &:hover {
    text-decoration: none;
  }
`;

export const List = styled(GrommetList)`
  ${(props) => mapPropsToStyles(props)};
  .row {
    align-items: flex-start;
    .checkbox {
      margin-top: 5px;
    }
    .chk-label {
      margin-left: 10px;
    }
  }
`;

export const Button = styled(GrommetButton)`
  ${(props) => mapPropsToStyles(props)};
`;

export const CheckBox = styled(GrommetCheckbox)`
  ${(props) => mapPropsToStyles(props)};
`;

export const Heading = styled(GrommetHeading)`
  ${(props) => mapPropsToStyles(props)};
`;

export const Image = styled(GrommetImage)`
  ${(props) => mapPropsToStyles(props)};
`;

export const Paragraph = styled(GrommetParagraph)`
  ${(props) => mapPropsToStyles(props)};
`;

export const Select = styled(GrommetSelect)`
  ${(props) => mapPropsToStyles(props)};
  font-size: 16px;
`;

export const Text = styled(GrommetText)`
  ${(props) => mapPropsToStyles(props)};

  &.condensePageNav {
    margin-left: -0.75rem;
  }
`;

export const ErrorMsg = styled(GrommetText)`
  ${(props) => mapPropsToStyles(props)};

  ${commonStyles.fontSize14};
  ${commonStyles.marginTop3};
  ${commonStyles.paddingLeft4};
  background: url(${iconError}) center left;
  background-repeat: no-repeat;
  color: #ca2b4e;
  &.hidden {
    display: none;
  }
`;

export const PageContentBox = styled(GrommetBox)`
  ${(props) => mapPropsToStyles(props)};

  ${commonStyles.paddingHorizontal5};
  ${commonStyles.mainContentTitleSpacing};
  border-left: 1px solid #e6e6e6;
`;

export const ContentBox = styled(GrommetBox)`
  ${(props) => mapPropsToStyles(props)};
  overflow: 'inherit';

  p,
  h1 {
    margin-top: 0;
  }
  h1 {
    line-height: 56px;
  }
`;

export const WizardContentBox = styled(ContentBox)`
  ${(props) => mapPropsToStyles(props)};
  margin-top: -12px;
`;

export const PageTitleBox = styled(GrommetBox)`
  ${(props) => mapPropsToStyles(props)};

  border-bottom: 1px solid #e6e6e6;
  ${commonStyles.marginBottom4};
  height: 112px;
  ${Text} {
    ${commonStyles.fontSize30};
    ${commonStyles.lineHeightCompact};
    ${commonStyles.veryDarkGray};
    ${commonStyles.semiBold};
  }
  &.noBottomBorder {
    border: 0px;
    margin-bottom: 0;
  }
  &.mobile {
    height: 150px;
    ${Box} {
      display: flex;
      justify-content: center;
      ${Text} {
        padding-bottom: 10px;
      }
    }
  }
`;

export const MenuIcon = styled(GrommetBox)`
  ${(props) => mapPropsToStyles(props)};

  height: 65px;
  // flex: 1 0 45px;
  ${Text} {
    ${commonStyles.fontSize18};
    ${commonStyles.regular};
    display: flex;
    align-items: center;
    padding-left: 10px;
  }
`;

export const PageTitleBoxNoBorder = styled(GrommetBox)`
  ${(props) => mapPropsToStyles(props)};

  ${commonStyles.marginBottom4};
`;

export const ShowdownBox = styled(GrommetBox)`
  ${(props) => mapPropsToStyles(props)};

  font-size: 18px;

  h1 {
    font-size: 24px;
    font-weight: 600;
  }

  p {
    margin: 10px 0;
    padding: 0px;
  }

  ul,
  ol {
    margin-top: 0px;
    margin-bottom: 0px;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  strong {
    ${commonStyles.semiBold};
  }
  &.checklist-content table {
    thead {
      ${commonStyles.semiBold};
    }
    tr {
      outline: thin solid;
    }
  }
`;

export const Video = styled(GrommetVideo)`
  ${(props) => mapPropsToStyles(props)};
`;

export const ModalTitleBox = styled(GrommetBox)`
  ${(props) => mapPropsToStyles(props)};
  ${commonStyles.marginBottom4};
  ${Text} {
    ${commonStyles.fontSize20};
    ${commonStyles.lineHeightCompact};
    ${commonStyles.veryDarkGray};
    ${commonStyles.semiBold};
  }
  ${Button} {
    padding: 0;
    border: 0;
    margin-top: -20px;
    margin-right: -20px;
  }
`;
export const ModalContent = styled(GrommetBox)`
  ${(props) => mapPropsToStyles(props)};
  p {
    max-width: inherit;
    margin: 10px 0;
  }
  a {
    ${commonStyles.lightDarkBlue};
    font-weight: normal;
  }
`;

export const Markdown = styled(GrommetMarkdown)`
  ${(props) => mapPropsToStyles(props)};
  font-size: 18px;

  h1 {
    font-size: 24px;
    font-weight: 600;
  }

  p {
    max-width: inherit;
    margin: 10px 0;
  }
  a {
    ${commonStyles.lightDarkBlue};
    font-weight: normal;
  }
  ul,
  ol {
    margin-top: 0px;
    margin-bottom: 0px;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  strong {
    ${commonStyles.semiBold};
  }

  img {
    max-width: 100%;
  }
`;

export const Loader = styled(GrommetBox)`
  ${(props) => mapPropsToStyles(props)};
  border: 16px solid #f3f3f3;
  border-top: 16px solid #3498db;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
  margin-right: auto;
  margin-left: auto;
  display: ${(props) => (props.isShow ? '' : 'none')};

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const NoFocusBorder = styled(GrommetBox)`
  button {
    box-shadow: none;
  }
`;

export const Layer = styled(GrommetLayer)`
  ${(props) => mapPropsToStyles(props)};

  &.feedbackModal {
    border-radius: 8px;
    width: 720px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
    @media (max-width: 768px) {
      width: 100%;
      max-width: 100vw;
    }
  }
`;

export const ModalCloseButton = styled(GrommetButton)`
  cursor: pointer;
  border-radius: 5px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  &:hover {
    background: #e5e8ec;
  }
`;
